import { createIdentityService } from "@foris/mango-core";
import { ENV, HAS_MULTITENANT, IDENTITY_TENANTS, IDENTITY_URL, USE_IDENTITY } from "@common/config";
import { useSettingsStore } from "@context/useSettingsStore";
import {
  getIdentityToken,
  setIdentityToken,
  removeIdentityToken,
} from "@context/useIdentityTokenStore";
import { toTenantCode } from "@utils/tenant";

export const setToken = (token: string): void => {
  setIdentityToken(token);
};

/**
 * Whether the deployment asks for Identity on the tenant of the URL: when VITE_IDENTITY_TENANTS
 * lists tenants, only those, whatever VITE_USE_IDENTITY says; otherwise VITE_USE_IDENTITY, for
 * every tenant.
 */
export const isIdentityRequiredByDeployment = (): boolean =>
  IDENTITY_TENANTS.length > 0
    ? IDENTITY_TENANTS.includes(toTenantCode(window.location.hostname, ENV).toLowerCase())
    : USE_IDENTITY;

/**
 * Determines whether Identity is required by the deployment or the agents chat.
 *
 * @returns Whether multitenancy is enabled and either activation source is enabled.
 */
export const isIdentityEnabled = (): boolean =>
  HAS_MULTITENANT &&
  (isIdentityRequiredByDeployment() || useSettingsStore.getState().isAgentsChatEnabled);

const { login, refresh, logout, startAutoRefresh, dispose } = createIdentityService({
  identityUrl: IDENTITY_URL ?? "",
  getToken: () => getIdentityToken(),
  setToken: ({ accessToken }) => setIdentityToken(accessToken),
  removeToken: () => removeIdentityToken(),
  isEnabled: isIdentityEnabled,
});

export { login, refresh, logout, startAutoRefresh, dispose };
